import { render, staticRenderFns } from "./TraitExportChartSelection.vue?vue&type=template&id=d177cd24&scoped=true&"
import script from "./TraitExportChartSelection.vue?vue&type=script&lang=js&"
export * from "./TraitExportChartSelection.vue?vue&type=script&lang=js&"
import style0 from "./TraitExportChartSelection.vue?vue&type=style&index=0&id=d177cd24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d177cd24",
  null
  
)

export default component.exports